module.exports = __webpack_public_path__ + "assets/img/icons8-portugal-144.0f2bf276.png";